import { ChangeDetectorRef, Component, Injector, Input } from "@angular/core";
import { ControlValueAccessorComponent } from "ng/src/app/shared/control-value-accessor.component";
import { TemplateWithUsers } from '../shared/template.model';
@Component({
	selector: 'lb-all-user-selector',
	template: `
		<ng-container *ngIf="value">
			<div>
				<p-radioButton name="all-users" label="All Users" [value]="true" [(ngModel)]="value.allowAllUsers"></p-radioButton>
			</div>
			<div class="p-pt-1">
		        <p-radioButton name="all-users" label="Specific Users" [value]="false" [(ngModel)]="value.allowAllUsers"></p-radioButton>
			</div>
			<div *ngIf="!value.allowAllUsers" class="p-pt-1">
				<lb-user-list-selector [logId]="logId" type="logUser" [(ngModel)]="value.allowedUsers">
				</lb-user-list-selector>
			</div>
		</ng-container>
	`,
	providers: [
		ControlValueAccessorComponent.getValueAccessorProvider(AllUserSelectorComponent)
	]
})
export class AllUserSelectorComponent extends ControlValueAccessorComponent<AllUserSelectorModel> {
	@Input() logId!: number
	
	constructor(
		protected injector: Injector
	) {
		super(injector);
	}
	
	writeValue(obj: AllUserSelectorModel | null) {
		super.writeValue(obj ?? this.getDefault());
		this.injector.get(ChangeDetectorRef).detectChanges();
	}
	
	protected getDefault(): AllUserSelectorModel {
		return {
			allowAllUsers: false,
			allowedUsers: []
		}
	}
}

export type AllUserSelectorModel = Pick<TemplateWithUsers, 'allowAllUsers' | 'allowedUsers'>;